import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ASSETS_PATH } from 'src/app/core/config';
import { EDUCATION_TYPES, USER_APPLICATION_STATUS_TYPES } from 'src/app/core/models/enum.model';
import { JudgeForm } from 'src/app/core/models/judgeForm.model';
import { RefereeForm } from 'src/app/core/models/refereeForm.model';
import { UserVolunteerModel } from 'src/app/core/models/user.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { ApplicationService } from 'src/app/core/services/application.service';
import { JudgeFormService } from 'src/app/core/services/judgeForm.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { RefereeFormService } from 'src/app/core/services/refereeForm.service';
import { UserService } from 'src/app/core/services/user.service';
import { VolunteerService } from 'src/app/core/services/volunteer.service';

@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.scss']
})
export class ViewProfileComponent implements OnInit {
  
  user = new UserVolunteerModel();
  educationLevels = EDUCATION_TYPES;
  assetsPath = ASSETS_PATH;
  isImage = false;
  isJudgeFilledBefore = false;
  isRefereeFilledBefore = false;
  judgeForm = new JudgeForm();
  refereeForm = new RefereeForm();
  applications = [];
  applicationStatusTypes = USER_APPLICATION_STATUS_TYPES;

  constructor(private alertService: AlertService,
    private volunteerService: VolunteerService,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private judgeFormService: JudgeFormService,
    private refereeFormService: RefereeFormService,
    private userService: UserService,
    private applicationService: ApplicationService) { }

  ngOnInit(): void {
    if (this.route.snapshot.params.id) {
      this.getVolunteer(this.route.snapshot.params.id);
      this.getJudgeForm(this.route.snapshot.params.id);
      this.getRefereeForm(this.route.snapshot.params.id);
      this.getUserApplicationList(this.route.snapshot.params.id);
    }
  }

  getVolunteer(id:string){
    this.loadingService.setLoading(true);
    this.volunteerService.getVolunteerProfile(id).subscribe(response => {
      if (response.success) {
        this.user = response;
        console.log(this.user);
        if (this.user.image !== null && this.user.image !== "") {
          this.isImage = true;
        }
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
  }

  getEducationLevel(status: number) {
    if (status === undefined || status === null) {
      return "";
    }
    let value = this.educationLevels.filter(x => x.code === status);

    if (value !== undefined && value !== null) {
      try{
        return value[0].text;
      }
      catch {
        return "";
      }
    }
  }

  getStatus(isContinue: boolean){
    if (isContinue) {
      return "Devam ediyor"
    }
    else {
      return "Tamamladı"
    }
  }

  getJudgeForm(id: string){
    this.loadingService.setLoading(true);
    this.judgeFormService.getJudgeForm(id).subscribe(res => {
      if (res.success) {
        this.judgeForm = res;
        this.isJudgeFilledBefore = res.isFilledBefore;
      }
      this.loadingService.setLoading(false);
    },
    (error) => {
      this.loadingService.setLoading(false);
      this.alertService.alert('Hata!', error.error.Message, 'error');
    });
  }

  getRefereeForm(id: string){
    this.loadingService.setLoading(true);
    this.refereeFormService.getRefereeForm(id).subscribe(res => {
      if (res.success) {
        this.refereeForm = res;
        this.isRefereeFilledBefore = res.isFilledBefore;
      }
      this.loadingService.setLoading(false);
    },
    (error) => {
      this.loadingService.setLoading(false);
      this.alertService.alert('Hata!', error.error.Message, 'error');
    });
  }

  activate(){
    this.loadingService.setLoading(true);
    this.userService.activateUser(this.user.id).subscribe(response => {
      if (response.success) {
        this.alertService.notification('Başarılı!', "Kullanıcı başarıyla aktifleştirildi", 'success');
        this.getVolunteer(this.user.id);
        if (this.user.image !== null && this.user.image !== "") {
          this.isImage = true;
        }
        this.loadingService.setLoading(false);
      }
    },
    (error) => {
      this.loadingService.setLoading(false);
      this.alertService.alert('Hata!', error.error.Message, 'error');
    });
  }

  getUserApplicationList(id: string){
    this.loadingService.setLoading(true);
    this.applicationService.getUserApplicationList(id).subscribe(res => {
      if (res.success) {
        this.applications = res.applications;
      }
      this.loadingService.setLoading(false);
    },
    (error) => {
      this.loadingService.setLoading(false);
      this.alertService.alert('Hata!', error.error.Message, 'error');
    });
  }

  getApplicationStatus(status: number) {
    if (status === undefined || status === null) {
      return "";
    }
    let value = this.applicationStatusTypes.filter(x => x.code === status);

    if (value !== undefined && value !== null) {
      try{
        return value[0].text;
      }
      catch {
        return "";
      }
    }
  }

}
